import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDotsHorizontal24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDotsHorizontal24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.5 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-6.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M7 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDotsHorizontal24);
